import { createSlice } from "@reduxjs/toolkit";


const initialState = [];

const bmiSlice = createSlice({
    name:'bmi',
    initialState,
    reducers:{}
})

export const {} = bmiSlice.actions;
export default bmiSlice.reducer;